import { LoginForm, ResetPasswordModal } from "../../components/pages";

export const Homepage = () => {
  return (
    <>
      <LoginForm />
      <ResetPasswordModal />
    </>
  );
};
